import { Component } from '@angular/core';


@Component({
  selector: 'lib-auth',
  imports: [],
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.css',
})
export class AuthComponent {}
